/* Keep shared upgrades attached to their light across drawer and /cart edits. */
(() => {
  'use strict';
  if (window.JLCartGuard) return;
  const grouped = items => items.some(item => item.properties?._jl_group);
  function corrections(items) {
    const parents = new Map();
    items.forEach(item => {
      const props = item.properties || {};
      if (props._jl_group && !Object.hasOwn(props, '_jl_heads')) {
        parents.set(props._jl_group, (parents.get(props._jl_group) || 0) + item.quantity);
      }
    });
    const updates = {};
    items.forEach(item => {
      const props = item.properties || {};
      if (!props._jl_group || !Object.hasOwn(props, '_jl_heads')) return;
      const heads = Number(props._jl_heads);
      // A malformed add-on cannot stand alone either.
      const expected = Number.isInteger(heads) && heads > 0 && heads <= 100 ? (parents.get(props._jl_group) || 0) * heads : 0;
      if (item.quantity !== expected) updates[item.key] = expected;
    });
    return updates;
  }
  let active = false, busy = false, pending = null;
  try { active = grouped(JSON.parse(document.getElementById('jl-cart-guard-state')?.textContent || '[]')); } catch { /* no initial data */ }
  const root = window.Shopify?.routes?.root || '/';
  async function reconcile(event) {
    if (event?.detail?.source === 'jl-cart-guard') return;
    if (busy) { pending = event || {}; return; }
    const supplied = event?.detail?.cartData?.items;
    if (Array.isArray(supplied) && grouped(supplied)) active = true;
    if (!active) return;
    busy = true;
    try {
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart read failed');
      const cart = await response.json();
      active = grouped(cart.items);
      const updates = corrections(cart.items);
      if (!Object.keys(updates).length) return;
      const renderers = [...document.querySelectorAll('cart-drawer, cart-notification, cart-items')];
      const sectionIds = [...new Set(renderers.flatMap(renderer => renderer.getSectionsToRender?.().map(s => s.section || s.id) || []))];
      // Shopify bundles at most five sections per Ajax request.
      const sections = sectionIds.slice(0, 5);
      // One batched fix per change event; our own refreshed event never re-enters.
      const fixed = await fetch(`${root}cart/update.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates, ...(sections.length ? { sections, sections_url: location.pathname } : {}) }),
      });
      if (!fixed.ok) throw new Error('Cart upgrade sync failed');
      const result = await fixed.json();
      if (result.status) throw new Error(result.description || 'Cart upgrade sync failed');
      active = grouped(result.items || []);
      // A cart page may contain a hidden drawer as well as its own cart-items.
      // Refresh both. Additional sections are read-only requests, never another fix.
      if (sectionIds.length > 5) {
        result.sections ||= {};
        for (let i = 5; i < sectionIds.length; i += 5) {
          const response = await fetch(`${location.pathname}?sections=${encodeURIComponent(sectionIds.slice(i, i + 5).join(','))}`, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Cart section refresh failed');
          Object.assign(result.sections, await response.json());
        }
      }
      renderers.forEach(renderer => {
        if (renderer.renderContents) { renderer.renderContents(result); return; }
        if (!result.sections) return;
        // Some /cart components expose descriptors but no renderContents method.
        renderer.getSectionsToRender?.().forEach(section => {
          const target = document.getElementById(section.id);
          const html = result.sections[section.section || section.id];
          if (!target || !html) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const fragment = section.selector ? parsed.querySelector(section.selector) : parsed.getElementById(section.id);
          const destination = section.selector ? (target.matches(section.selector) ? target : target.querySelector(section.selector)) : target;
          if (fragment && destination) destination.innerHTML = fragment.innerHTML;
        });
      });
      document.dispatchEvent(new CustomEvent('afterCartChanged', { detail: { source: 'jl-cart-guard', cartData: result } }));
    } catch (error) {
      console.warn('Shared upgrade cart sync:', error.message);
    } finally {
      busy = false;
      if (pending) { const next = pending; pending = null; void reconcile(next); }
    }
  }
  window.JLCartGuard = { corrections, reconcile };
  document.addEventListener('afterCartChanged', reconcile);
  document.addEventListener('afterUpdateQuantity', reconcile);
  reconcile();
})();
